'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _activeModalActions = require('../../actions/activeModalActions');

var _Modals = require('./Modals');

var _Modals2 = _interopRequireDefault(_Modals);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var mapStateToProps = function mapStateToProps(_ref) {
  var activeModal = _ref.activeModal;
  return {
    activeModal: activeModal
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setActiveModal: function setActiveModal() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return dispatch((0, _activeModalActions.setActiveModal)(id, params));
    }
  };
};

exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_Modals2.default);